import request from '@/utils/request'
import qs from 'qs'

export const getHotTop = (params) => {
    return new request({
        url: './article/articleInfos/getTop10',
        method: 'get',
        params:params,
        headers:{
            type:'notice',
        }
    });
}
export const getInfo = (params) => {
    return new request({
        url: './article/articleInfos',
        method: 'get',
        params:params,
        headers:{
            type:'notice',
        }
    });
}
export const getInfoId = (id) => {
    return new request({
        url: './article/articleInfos/'+id,
        method: 'get',
        headers:{
            type:'notice',
        }
    });
}
